export default __webpack_public_path__ + "static/media/ticket-field-change.81432206.svg";